import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonInput from "../../../CommonComponents/CommonInput";
import CustomSelect from "../../../CommonComponents/Select/CustomSelect";
import { ArrowDropDown } from "@mui/icons-material";
import VendorUpload from "../../../CommonComponents/VendorUpload/VendorUpload";

const labelStyles = {
  marginBottom: "1rem",
  color: "#3a3a3a",
  fontSize: "1.25rem",
  fontWeight: 500,
};

const dropdownStyles = {
  fontSize: "1.2rem",
  ".MuiSvgIcon-root ": {
    fontSize: "4rem",
    color: "#7C7C7C",
  },
  ".makeStyles-placeholder-1": {
    color: "#5E6366",
  },
  ".MuiPopover-root.MuiMenu-paper.Mui-focused": {
    borderRadius: "4px 4px 0 0",
  },
};

const menuProps = {
  PaperProps: {
    sx: {
      bgcolor: "#ebeef8",
      borderRadius: "0 0 4px 4px",
    },
  },
};

const formContents = [
  {
    name: "legalName",
    label: "Legal Name",
    type: "select",
    placeholder: "Select",
    options: [
      "ABCD Pvt. Ltd.",
      "ABCD Pvt. Ltd.",
      "ABCD Pvt. Ltd.",
      "ABCD Pvt. Ltd.",
    ],
    required: true,
    lg: 2,
    md: 4,
  },
  {
    name: "tradeName",
    label: "Trade Name",
    type: "select",
    placeholder: "Select",
    options: [
      "ABCD Pvt. Ltd.",
      "ABCD Pvt. Ltd.",
      "ABCD Pvt. Ltd.",
      "ABCD Pvt. Ltd.",
    ],
    required: true,
    lg: 2,
    md: 4,
  },
  {
    name: "city",
    label: "City",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 1,
    md: 4,
  },
  {
    name: "address",
    label: "Address",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 3,
    md: 4,
  },
  {
    name: "pincode",
    label: "Pincode",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 1,
    md: 4,
  },
  {
    name: "state",
    label: "State",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 2,
    md: 4,
  },
  {
    name: "capacity",
    label: "Capacity",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 1,
    md: 4,
  },
  {
    name: "tan",
    label: "TAN",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 2,
    md: 4,
  },
  {
    name: "cst",
    label: "CST",
    type: "input",
    placeholder: "Enter",
    required: false,
    lg: 2,
    md: 4,
  },
  {
    name: "hsn",
    label: "HSN",
    type: "input",
    placeholder: "Enter",
    required: false,
    lg: 2,
    md: 4,
  },
  {
    name: "sac",
    label: "SAC",
    type: "input",
    placeholder: "Enter",
    required: false,
    lg: 2,
    md: 4,
  },
  {
    name: "msme",
    label: "MSME",
    type: "select",
    placeholder: "Y/N",
    required: true,
    options: ["Yes", "No"],
    lg: 2,
    md: 4,
  },
  {
    name: "msmeRegNo",
    label: "MSME Reg. No.",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 2,
    md: 4,
  },
  {
    name: "mobile1",
    label: "Contact 1 (Mobile)",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 3,
    md: 4,
  },
  {
    name: "email1",
    label: "Contact 1 (Email)",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 3,
    md: 4,
  },
  {
    name: "mobile2",
    label: "Contact 2 (Mobile)",
    type: "input",
    placeholder: "Enter",
    required: false,
    lg: 3,
    md: 4,
  },
  {
    name: "email2",
    label: "Contact 2 (Email)",
    type: "input",
    placeholder: "Enter",
    required: false,
    lg: 3,
    md: 4,
  },
  {
    name: "nature",
    label: "Nature of Firm",
    type: "input",
    placeholder: "Enter",
    required: true,
    lg: 3,
    md: 4,
  },
  {
    name: "uploadedDoc",
    label: "Upload Doc",
    type: "selectUpload",
    placeholder: "Select",
    options: [
      "Aadhaar",
      "Utility Bill",
      "Passport",
      "Voter ID",
      "Firm AOA",
      "Firm MOA",
      "Firm Reg. Cert.",
    ],
    required: true,
    lg: 3,
    md: 4,
  },
  {
    name: "uploadedMSME",
    label: "Upload MSME",
    type: "upload",
    placeholder: "Upload",
    required: false,
    lg: 3,
    md: 4,
  },
];

const validateForm = (details) => {
  let isValid = true;
  for (let i = 0; i < formContents?.length; i++) {
    let obj = formContents?.[i];
    if (obj?.required && !details?.[obj?.name]) {
      isValid = false;
      break;
    }
  }
  return isValid;
};

function CompanyDetails({
  setIsBtn1Active,
  setIsBtn2Active,
  saveClicked,
  nextClicked,
  onSaveClick,
  onNextClick,
}) {
  const [details, setDetails] = useState({});

  const onChangeHandler = (e, field) => {
    const name = e?.target?.name;
    setDetails((prev) => ({
      ...prev,
      [name]:
        name === "uploadedDoc"
          ? {
              type: field === "select" ? e?.target?.value : prev?.[name]?.type,
              file:
                field === "upload" ? e?.target?.files[0] : prev?.[name]?.file,
            }
          : name === "uploadedMSME"
          ? e?.target?.files[0]
          : e?.target?.value,
    }));
  };

  useEffect(() => {
    if (saveClicked) onSaveClick();
    if (nextClicked) onNextClick();
  }, [saveClicked, nextClicked]);

  useEffect(() => {
    let isRequiredFilled = validateForm(details);
    if (isRequiredFilled) {
      setIsBtn1Active(true);
      setIsBtn2Active(true);
    } else {
      setIsBtn1Active(false);
      setIsBtn2Active(false);
    }
  }, [details]);

  return (
    <Box>
      <Grid container columnSpacing={3} rowGap={2}>
        {formContents?.map((item) => {
          let value = details?.[item?.name];
          return (
            <Grid
              key={item?.label}
              item
              lg={item?.type === "selectUpload" && value?.file ? 4 : item?.lg}
              md={item?.md}
            >
              {item?.type === "input" ? (
                <CommonInput
                  name={item?.name}
                  label={item?.label}
                  value={value}
                  placeholder={item?.placeholder}
                  padding={"0.8rem 1.25rem"}
                  backgroundColor={"#ebeef8"}
                  outlineStyle={{
                    height: "auto",
                    paddingRight: "inherit",
                  }}
                  focusedStyles={{
                    background: "white",
                    border: "1px solid #5570F1",
                  }}
                  sx={{
                    border: value ? "1px solid #5570F1" : "1px solid #ebeef8",
                    input: {
                      "&::placeholder": {
                        textOverflow: "ellipsis !important",
                        color: "#5E6366",
                        opacity: 1,
                        fontSize: "1.2rem",
                      },
                      padding: "1rem",
                      fontSize: "1.2rem",
                    },
                    ".MuiInputAdornment-root": {
                      display: "none",
                    },
                  }}
                  removeBackGround={value}
                  onChange={onChangeHandler}
                  required={item?.required}
                />
              ) : item?.type === "select" ? (
                <CustomSelect
                  name={item?.name}
                  label={item?.label}
                  labelStyles={labelStyles}
                  afterSx={{
                    ...dropdownStyles,
                    background: value ? "white" : "#ebeef8",
                    border: `1px solid ${value ? "#5570F1" : "#ebeef8"}`,
                  }}
                  placeholder={item?.placeholder}
                  customSelectValue={value}
                  options={item?.options}
                  handleChange={onChangeHandler}
                  dropDownIcon={ArrowDropDown}
                  menuProps={menuProps}
                  required={item?.required}
                />
              ) : (
                <VendorUpload
                  name={item?.name}
                  header={item?.label}
                  label={item?.label}
                  placeholder={item?.placeholder}
                  uploadedDocuments={{
                    [item?.label]: {
                      filename:
                        item?.type === "selectUpload"
                          ? value?.file?.name
                          : value?.name,
                      fileUrl:
                        item?.type === "selectUpload" && value?.file
                          ? URL.createObjectURL(value?.file)
                          : item?.type === "upload" && value
                          ? URL.createObjectURL(value)
                          : "",
                    },
                  }}
                  onChangeHandler={(e) => onChangeHandler(e, "upload")}
                  onlyIcon={item?.type === "selectUpload" ? true : false}
                  options={item?.options}
                  onSelect={(e) => onChangeHandler(e, "select")}
                  value={value?.type}
                  disabled={value?.type ? false : true}
                  uploadedImg={true}
                  viewImg={true}
                  required={item?.required}
                />
              )}
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default CompanyDetails;
